module.exports = __webpack_public_path__ + "img/Nishita-Bhanushali.8d5cbe40.jpg";